import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import ShortCardDashobard from "../CardDashboard/ShortCardDashobard/ShortCardDashobard";
import {Col, DatePicker, Row, Select, Spin} from "antd";
import './AlertRiskCard.scss'
import { getResumeAlertsPromise, getResumeAlertsByCategoryPromise } from "../../../../promises";
import moment from "moment";


const AlertRiskCard = ({categories, globalActiveCategory, handleTabAlertas}) => {

    const {t} = useTranslation()

    const [alertResume, setAlertResume] = useState([]);
    const [activeCategory, setActiveCategory] = useState(globalActiveCategory)
    const [countAlerts, setCountAlerts] = useState([])
    const [activeAlertType, setActiveAlertType] = useState(null);
    const [activeDateRange, setActiveDateRange] = useState(null);


    let filter = {}

    let filterResume = {
        dateRange: null
    }

    const alertType = ["PERSONA", "DEMOGRAFICA", "TRANSACCIONAL"]

    useEffect(() => {
        handleSearch();
    }, [activeCategory]);

    useEffect(() => {
        handleSearchResume(filterResume);
    }, [activeAlertType, activeDateRange]);

    /* left card */
    const handleSearch = async () => {
        activeCategory ? filter.category = activeCategory : delete filter.category
        getResumeAlertsPromise(filter).then(response => {
            setAlertResume(response.data);
        })
    };

    const getFilters = (risk) => {
        let filters = {risks: [risk]}
        if(activeCategory) filters.categories = [activeCategory]
        return filters
    }

    const getFiltersCategory = (category, states) => {
        let filters = {categories: [category]}
        if(states) filters.states = states
        if(activeAlertType) filters.types = [activeAlertType]
        if(activeDateRange && activeDateRange.length === 2) filters.fechaAlerta = activeDateRange
        return filters
    }

    const contentAlertRisk = () => {

        let countCriticalRisk = 0
        alertResume.map(resume => {
            if (resume.risk === 4) {
                countCriticalRisk += resume.alertCount
            }
        })

        let countHighRisk = 0
        alertResume.map(resume => {
            if (resume.risk === 3) {
                countHighRisk += resume.alertCount
            }
        })

        return (<>
            <div>
                <Row>
                    <Col span={10}>
                        <Select
                            style={{width: "100%"}}
                            value={activeCategory}
                            onChange={(value) => setActiveCategory(value)}
                        >
                            <Select.Option value={null}> {t('messages.aml.category')} </Select.Option>
                            {categories.map((category, index) =>
                                <Select.Option value={category}>
                                    {t('messages.aml.category.' + category)}
                                </Select.Option>
                            )}
                        </Select>
                    </Col>
                </Row>
                <br/>
            </div>

            <div className={"alert-resume-text"}>
                <div>{t('messages.aml.monitor.alerts.pending.manage')}</div>
                &nbsp;
                <div>
                { countCriticalRisk > 0 ?
                    <a onClick={() => handleTabAlertas(getFilters(4))}><span className={"notification-count"}>{countCriticalRisk}</span></a>
                :
                    <span className={"notification-count"}>{countCriticalRisk}</span>
                } {t('messages.aml.monitor.alerts.of.critical')}
                </div>
                <div>
                { countHighRisk > 0 ?
                    <a onClick={() => handleTabAlertas(getFilters(3))}><span className={"notification-count"}>{countHighRisk}</span></a>
                    :
                    <span className={"notification-count"}>{countHighRisk}</span>
                } {t('messages.aml.monitor.alerts.of.high')}
                </div>
            </div>

        </>)
    }

    /*right card*/
    const handleSearchResume = (filterResume) => {

        filterResume.dateRange = activeDateRange
        filterResume.alertType = activeAlertType

        getResumeAlertsByCategoryPromise(filterResume).then(response => {
            setCountAlerts(response.data)
        })
    }

    const handleSetActiveAlertType = (alertType) => {
        setActiveAlertType(alertType);
    };

    const handleSetActiveDateRange = (dateRange) => {
        setActiveDateRange(dateRange)
    }

    const contentPendingAlerts = () => {

        return (
            <>
                <div>{activeDateRange
                    ? t('messages.aml.monitor.alerts.pending.by.category.period')
                    : t('messages.aml.monitor.alerts.pending.by.category.month')
                }</div>
                <br/>
                <Row>
                    <div className={"resume-alert-info"}>
                        {
                            countAlerts.map((cont) =>
                                <Col span={12}>
                                    {cont.category && 
                                        <a onClick={() => handleTabAlertas(getFiltersCategory(cont.category, ["OPEN", "READY"]))}>
                                            <div className={"count-info"}>
                                                {t('messages.aml.category.' + cont.category)} : {cont?.alertsOpen}
                                            </div>
                                        </a>
                                    }
                                </Col>
                            )}

                        {countAlerts?.length === 0 &&
                            (<div>{t('messages.aml.monitor.no.info')}</div>)
                        }
                    </div>
                </Row>
                <br/>
                <Row>
                    <Col span={12}>
                        <DatePicker.RangePicker
                            placeholder={[t('messages.aml.from'), t('messages.aml.to')]}
                            style={{width: "100%"}}
                            value={
                                activeDateRange
                                ? [
                                    moment(activeDateRange[0]),
                                    moment(activeDateRange[1]),
                                    ]
                                : null
                            }
                            onChange={momentData => {
                                handleSetActiveDateRange(
                                    momentData !== null && momentData.length > 0 ?
                                        [
                                            moment(momentData[0]).valueOf(),
                                            moment(momentData[1]).valueOf(),
                                        ]
                                        : null)
                            }}
                        />
                    </Col>

                    <Col span={8} offset={3}>
                        <Select
                            style={{width: "100%"}}
                            value={activeAlertType}
                            placeholder={t('messages.aml.monitor.type.alert')}
                            onChange={value => handleSetActiveAlertType(value)}
                        >
                            <Select.Option value={null}>{t('messages.aml.monitor.type.alert')}</Select.Option>
                            {alertType.map((type, index) => (
                                <Select.Option value={type}>
                                    {t('messages.aml.monitor.alertas.' + type)}
                                </Select.Option>
                            ))}
                        </Select>
                    </Col>

                </Row>
            </>)
    }

    return (
        <>
            <div className='alert-info-card'>
                <Row gutter={16} type="flex">

                    <Col span={12}>
                        <div className="left-card">
                            {!alertResume ?
                                <div className="cake-is-loading">
                                    <Spin spinning={true}/>
                                </div> :
                                <ShortCardDashobard
                                    title={t('messages.aml.monitor.alerts.critical.high')}
                                    content={contentAlertRisk()}
                                />}
                        </div>
                    </Col>

                    <Col span={12}>
                        <div className="right-card">
                            {!alertResume ?
                                <div className="cake-is-loading">
                                    <Spin spinning={true}/>
                                </div>
                                :
                                <ShortCardDashobard
                                    title={t('messages.aml.monitor.alerts.pending.category')}
                                    content={contentPendingAlerts()}
                                />}
                        </div>
                    </Col>
                </Row>
            </div>

        </>

    )
}

export default AlertRiskCard;